<script>
  export let title = "default title";
  export let total = 0;
</script>

<section class="main-title">
  <h2>{title} : $ {total}</h2>
</section>
